// import { useEffect, useState } from "react";
// import {
//   Button,
//   message,
//   Table,
//   Flex,
//   Input,
//   DatePicker,
//   TreeSelect,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   FolderOpenOutlined,
// } from "@ant-design/icons";
// import { fetchBuilders, deleteBuilder } from "../Service/checklistBuilder";
// import { useNavigate } from "react-router-dom";
// import dayjs from "dayjs";
// import { fetchProduct } from "../../../../../configuration/module/Product/Service/product";
// import { buildTreeData } from "../../../../../configuration/module/Product/Component/product";

// const { RangePicker } = DatePicker;

// const ChecklistBuilder = () => {
//   const [builders, setBuilders] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState("");
//   const [productList, setProductList] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [dateRange, setDateRange] = useState([]);
//   const navigate = useNavigate();

//   // Fetch checklist builders
//   const fetchData = async (filters = {}) => {
//     setLoading(true);
//     try {
//       const res = await fetchBuilders(filters);
//       setBuilders(res.data);
//     } catch (err) {
//       message.error("Network error while fetching builders");
//     }
//     setLoading(false);
//   };

//   // Fetch products
//   const getProductlist = async () => {
//     try {
//       const res = await fetchProduct();
//       setProductList(buildTreeData(res.data));
//     } catch (err) {
//       message.error("Network error while fetching products");
//       setProductList([]);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     getProductlist();
//   }, []);

//   // Delete builder
//   const deleteData = async (id) => {
//     try {
//       await deleteBuilder(id);
//       message.success("Checklist Builder deleted successfully");
//       fetchData();
//     } catch (err) {
//       message.error("Error while deleting builder");
//     }
//   };

//   // Apply filters
//   const applyFilters = () => {
//     const filters = {};
//     if (search) filters.search = search;
//     if (selectedProduct) filters.product = selectedProduct;
//     if (dateRange?.length === 2) {
//       filters.fromDate = dateRange[0].format("YYYY-MM-DD");
//       filters.toDate = dateRange[1].format("YYYY-MM-DD");
//     }
//     fetchData(filters);
//   };

//   // Parent table columns
//   const columns = [
//     { title: "ID", dataIndex: "id", key: "id" },
//     {
//       title: "Checklist Name",
//       dataIndex: "checklistName",
//       key: "checklistName",
//     },
//     { title: "Product Name", dataIndex: "productName", key: "productName" },
//     {
//       title: "Created At",
//       dataIndex: "createdAt",
//       key: "createdAt",
//       render: (val) => val && dayjs(val).format("DD MMMM YYYY HH:mm"),
//     },
//     {
//       title: "Updated At",
//       dataIndex: "updatedAt",
//       key: "updatedAt",
//       render: (val) => val && dayjs(val).format("DD MMMM YYYY HH:mm"),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <FolderOpenOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`view/${record.id}`)}
//           />
//           <EditOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`edit/${record.id}`)}
//           />
//           <DeleteOutlined
//             style={{ cursor: "pointer" }}
//             onClick={() => deleteData(record.id)}
//           />
//         </>
//       ),
//     },
//   ];

//   return (
//     <div style={{ width: "100%" }}>
//       <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
//         <div style={{ fontSize: "1rem", fontWeight: 700 }}>
//           Checklist Builder
//         </div>
//       </Flex>

//       {/* Filters */}
//       <Flex gap={12} style={{ marginBottom: 16 }}>
//         <Input
//           placeholder="Search checklist name..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           style={{ width: 200 }}
//         />
//         <TreeSelect
//           value={selectedProduct}
//           onChange={(val) => setSelectedProduct(val)}
//           treeData={productList}
//           placeholder="Search Product..."
//           allowClear
//           style={{ width: 200 }}
//           treeDefaultExpandAll={false}
//         />
//         <RangePicker value={dateRange} onChange={(val) => setDateRange(val)} />
//         <Button type="primary" onClick={applyFilters}>
//           Apply
//         </Button>
//         <Button
//           onClick={() => {
//             setSearch("");
//             setSelectedProduct(null);
//             setDateRange([]);
//             fetchData();
//           }}
//         >
//           Reset
//         </Button>
//         <Flex flex={1} justify="flex-end">
//           <Button onClick={() => navigate({ pathname: "add" })} type="primary">
//             Add
//           </Button>
//         </Flex>
//       </Flex>

//       {/* Table */}
//       <Table
//         rowKey="id"
//         columns={columns}
//         scroll={{ x: "max-content" }}
//         dataSource={builders}
//         loading={loading}
//         bordered
//       />
//     </div>
//   );
// };

// export default ChecklistBuilder;
import { useEffect, useRef, useState } from "react";
import {
  Button,
  message,
  Table,
  Flex,
  Input,
  DatePicker,
  TreeSelect,
  Spin,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { fetchBuilders, deleteBuilder } from "../Service/checklistBuilder";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { fetchProduct } from "../../../../../configuration/module/Product/Service/product";
import { buildTreeData } from "../../../../../configuration/module/Product/Component/product";

const { RangePicker } = DatePicker;

const ChecklistBuilder = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // pagination
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [total, setTotal] = useState(0);

  // filters
  const [search, setSearch] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  // sorting
  const [sortField, setSortField] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("descend");

  const searchTimer = useRef(null);

  // ================= FETCH =================
  const fetchData = async (pageNum = page, pageSize = size, overrides = {}) => {
    setLoading(true);
    try {
      const params = {
        page: pageNum - 1,
        size: pageSize,
        search: search || undefined,
        productId: selectedProduct || undefined,
        fromDate:
          dateRange?.length === 2
            ? dateRange[0].format("YYYY-MM-DD")
            : undefined,
        toDate:
          dateRange?.length === 2
            ? dateRange[1].format("YYYY-MM-DD")
            : undefined,
        sort: sortField,
        desc: sortOrder === "descend",
        ...overrides,
      };

      const res = await fetchBuilders(params);

      setData(res.data?.content || []);
      setTotal(res.data?.totalElements || 0);
      setPage(pageNum);
      setSize(pageSize);
    } catch {
      message.error("Network error while fetching builders");
    } finally {
      setLoading(false);
    }
  };

  // ================= PRODUCTS =================
  const getProductList = async () => {
    try {
      const res = await fetchProduct();
      setProductList(buildTreeData(res.data));
    } catch {
      message.error("Network error while fetching products");
    }
  };

  // ================= INIT =================
  useEffect(() => {
    fetchData();
    getProductList();
  }, []);

  // ================= SEARCH (DEBOUNCED) =================
  useEffect(() => {
    if (searchTimer.current) clearTimeout(searchTimer.current);

    searchTimer.current = setTimeout(() => {
      fetchData(1, size);
    }, 500);

    return () => clearTimeout(searchTimer.current);
  }, [search]);

  // ================= DELETE =================
  const deleteData = async (id) => {
    try {
      await deleteBuilder(id);
      message.success("Checklist Builder deleted successfully");
      fetchData();
    } catch {
      message.error("Error while deleting builder");
    }
  };

  // ================= FILTER ACTIONS =================
  const applyFilters = () => fetchData(1, size);

  const resetFilters = () => {
    setSearch("");
    setSelectedProduct(null);
    setDateRange([]);
    fetchData(1, size, {
      search: undefined,
      productId: undefined,
      fromDate: undefined,
      toDate: undefined,
    });
  };

  // ================= COLUMNS =================
  const columns = [
    { title: "ID", dataIndex: "id", key: "id", width: 80 },
    {
      title: "Checklist Name",
      dataIndex: "checklistName",
      key: "checklistName",
      sorter: true,
      sortOrder: sortField === "checklistName" ? sortOrder : null,
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      sorter: true,
      sortOrder: sortField === "checklistName" ? sortOrder : null,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
    },
    {
      title: "Actions",
      key: "actions",
      width: 140,
      align: "center",
      render: (_, record) => (
        <>
          <FolderOpenOutlined
            style={{ marginRight: 12, cursor: "pointer" }}
            onClick={() => navigate(`view/${record.id}`)}
          />
          <EditOutlined
            style={{ marginRight: 12, cursor: "pointer" }}
            onClick={() => navigate(`edit/${record.id}`)}
          />
          <DeleteOutlined
            style={{ cursor: "pointer" }}
            onClick={() => deleteData(record.id)}
          />
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: 16 }}
        >
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>
            Checklist Builder
          </div>
        </Flex>

        {/* Filters */}
        <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
          <Input
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 200 }}
            allowClear
          />

          <TreeSelect
            value={selectedProduct}
            onChange={setSelectedProduct}
            treeData={productList}
            placeholder="Select product"
            allowClear
            style={{ width: 220 }}
          />

          <RangePicker
            value={dateRange}
            onChange={setDateRange}
            style={{ width: 260 }}
          />

          <Button type="primary" onClick={applyFilters}>
            Apply
          </Button>
          <Button onClick={resetFilters}>Reset</Button>

          <Flex flex={1} justify="end">
            <Button type="primary" onClick={() => navigate("add")}>
              + Add
            </Button>
          </Flex>
        </Flex>

        {/* Table */}
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          bordered
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          onChange={(pagination, filters, sorter) => {
            setSortField(sorter.field || sortField);
            setSortOrder(sorter.order || sortOrder);

            fetchData(pagination.current, pagination.pageSize, {
              sort: sorter.field || sortField,
              desc: sorter.order === "descend",
            });
          }}
        />
      </div>
    </Spin>
  );
};

export default ChecklistBuilder;
